<script>
  import { Router, Link, links, Route } from "svelte-routing";

  import { onMount, tick, createEventDispatcher } from "svelte";

  import FolderExplorer from "./folderExplorer.html";
  import api_handleApiCalls from "../utils/apiCallHandler.js";

  let modalCmp;
  let batchList = [];
  let elemBatchId;
  let saveBtnEle;
  let selectedFolder = [];
  let selectedBatch;

  async function api_getBatch(data) {

    let action = "batch.listBatches";
    var response = await api_handleApiCalls(action, data);
    return response;

  }

  const dispatch = createEventDispatcher();

  let onSelectedFolder = function () {
    feather.replace();
    dispatch("close", {
      selectedFolder: selectedFolder,
    });
  };

  onMount(async () => {
    feather.replace();

    _$(elemBatchId).selectize({
      maxItems: 1,
      valueField: "_id",
      labelField: "name",
      searchField: "name",
      options: [],
      preload: true,
      create: false,

      load: async (query, callback) => {
        // console.log(query);
        var batchRes = await api_getBatch({ search: query, start: "0" ,noPagination:true});
        if (batchRes.status) {
          batchList = batchRes.data.data;
          callback(batchList);
        }
      },
      onChange: function (value) {
        // console.log(value);
        let batchId = value;
        selectedBatch = undefined;
        tick();
        selectedBatch = batchId;
        tick();
      },
    });
    // _$(elemBatchId).select2({
    //     minimumResultsForSearch: Infinity,
    //     data: batchList.map(function (aBatchId) {
    //         return {
    //             id: (aBatchId._id),
    //             text: aBatchId.name,
    //         }
    //     })
    // });

    // _$(elemBatchId).on('select2:select', function (e) {
    //     var data = e.params.data;
    //     //console.log(data);
    //     let batchId = data.id;
    //     selectedBatch = undefined;
    //     tick();
    //     selectedBatch = batchId;
    //     tick();
    // });

    _$(modalCmp).modal("show");

    _$(modalCmp).on("hide.bs.modal", function (e) {
      dispatch("close", {
        selectedFolder: [],
      });
    });
  });
</script>

<div class="modal effect-scale" bind:this={modalCmp} id="pdf-add-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content ">
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-20">
        <a href="" role="button" class="close pos-absolute t-15 r-15 z-index-10" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block"><i data-feather="folder-plus" class="wd-60 ht-60" /></span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">Select folder</h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Select the folder which you want to add.
            </p>
          </div>
        </div>
        <!-- media -->
      </div>
      <!-- modal-header -->
      <hr class="full-width" />
      <div class="modal-body">
        <div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div class="row row-sm mg-b-20">
            <div class="col-sm-12">
              <div class="form-group col-sm-12">
                <label class="d-block">Select a Batch</label>
                <select bind:this={elemBatchId} style="width: 100%;" class="moduleSub form-control">
                  <option value="" disabled="disabled" selected>Select Batch</option>
                </select>
              </div>

              <div class="form-group col-sm-12">
                <label class="d-block">Select a Folder</label>
                {#if selectedBatch}
                <FolderExplorer bind:selectedFolder _batchId={selectedBatch} />
                <!-- <div class="custom-tree ">
                                        <div class="root">
                                            <span class="action-span"></span>
                                        </div>
                                        <ul class="custom-tree-holder">
                                        </ul>
                                    </div> -->
                {/if}
              </div>
              <div class="form-group col-sm-12">
                <label class="d-block">Selected Location : </label>
                {#if selectedBatch}
                <nav aria-label="breadcrumb " class="tree-bc">
                  <ol class="breadcrumb breadcrumb-style3 mg-b-0">
                    {#each selectedFolder as item}
                    <li class="breadcrumb-item active">{item.name}</li>
                    {/each}
                  </ol>
                </nav>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pd-r-25">
        <button type="button" class="btn btn-secondary tx-12" data-dismiss="modal">
          CLOSE
          <i data-feather="x" class="wd-10 mg-l-5" />
        </button>
        {#if selectedFolder.length == 0}
        <button type="button" on:click={onSelectedFolder} class="btn btn-primary tx-13" bind:this={saveBtnEle}
          disabled="false">
          LINK HERE
          <i data-feather="link" class="wd-10 mg-l-5" />
        </button>
        {:else}
        <button type="button" on:click={onSelectedFolder} class="btn btn-primary tx-13" bind:this={saveBtnEle}>
          LINK HERE
          <i data-feather="link" class="wd-10 mg-l-5" />
        </button>
        {/if}
      </div>
    </div>
  </div>
</div>